<template>
  <div class="visit-success-page">
    <img src="../assets/face logo.png">

    <div class="info">
      Wichtige Information zum Thema COVID-19 / Contact-Tracing
    </div>

    <div class="title">
      Face Club COVID-19 Tracking
    </div>

    <div class="subtitle">
      Du hast es fast geschafft! <br/>
      Du erhältst eine SMS auf der angegebenen Telefonnummer.<br/>
      Bitte klicke auf den Link in der SMS, um deine
      Registrierung abzuschliessen.<br/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "UserVisitPreValidationPage",
  }
</script>

<style lang="scss">
  @import "UserVisitPreValidationPage";
</style>
